/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateContractResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'Contract',
      },
    },
  }],
} as const;
